export default {"src":"/_next/static/media/renewable_energy_64.360d9ce4.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};